export default "__VITE_ASSET__Cxmxg4Nl__"